/**
 * #1611 — what every estimate→job button says when the job lands.
 *
 * Both converters (`convert-to-job`, `create-followup-job`) return the same
 * scope summary: how many devices were linked, and the estimate lines that
 * named a device the site doesn't have. Those lines are never guessed and
 * never block — the office is told "3 lines didn't match a device — pick or
 * create" and the job's scope note lists them.
 */
export interface ConversionScope {
    devicesLinked?: number;
    woLinked?: boolean;
    needsDevices?: boolean;
    unmatchedLines?: Array<{ lineId: string; description: string; reason: string | null }>;
    /** Server-worded: "3 lines didn't match a device — pick or create". */
    unmatchedMessage?: string | null;
}

/** The toast after a conversion. `warn` = something needs the office's hand. */
export function conversionToast(
    data: ConversionScope | null | undefined,
    fallback = "Job created",
): {
    text: string;
    warn: boolean;
} {
    if (!data || typeof data.devicesLinked !== "number") return { text: fallback, warn: false };
    const n = data.devicesLinked;
    const bits = [`Job created — ${n} device${n === 1 ? "" : "s"} linked`];
    if (data.woLinked) bits.push("work order attached");
    if (data.unmatchedMessage) bits.push(`${data.unmatchedMessage} on the job`);
    else if (data.needsDevices) bits.push("add the quoted devices on the job");
    return { text: bits.join("; "), warn: Boolean(data.unmatchedMessage) || Boolean(data.needsDevices) };
}
